var React = require('react');

function ArrowCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1 1)"},[React.createElement("g",{"transform":"translate(20.628 45.396) rotate(-90)","key":0},React.createElement("path",{"d":"M.348,16.233a1.184,1.184,0,0,0,1.677,0L15.4,2.86,28.767,16.234a1.186,1.186,0,0,0,1.677-1.677L16.234.348a1.184,1.184,0,0,0-1.677,0L.348,14.557a1.184,1.184,0,0,0,0,1.677Z","fill":"currentColor"})),React.createElement("circle",{"cx":"30","cy":"30","r":"30","transform":"translate(60 60) rotate(180)","fill":"none","stroke":"currentColor","strokeWidth":"2","key":1})]));
}

ArrowCircle.defaultProps = {"viewBox":"0 0 62 62"};

module.exports = ArrowCircle;

ArrowCircle.default = ArrowCircle;
